import { api } from '../index';
import apiUrls from '../../../settings/api-urls';
import { interpolate } from '../../../utilities';

export const rulesApi = api.injectEndpoints({
    endpoints: (build) => ({
        getRules: build.query({
            query: () => ({
                url: apiUrls.RULES,
                method: 'GET',
            }),
            transformResponse(res) {
                // sort results by createdAt descending
                return res.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            },
            providesTags: [ 'RULES' ],
        }),
        getRuleById: build.query({
            query: (id) => ({
                url: interpolate(apiUrls.RULE, { ruleId: id }),
                method: 'GET',
            }),
            providesTags: [ 'RULE' ],
        }),
        createRule: build.mutation({
            query: (body) => ({
                url: apiUrls.RULES,
                method: 'POST',
                body,
            }),
            invalidatesTags: [ 'RULES' ],
        }),
        updateRule: build.mutation({
            query: ({ id, body }) => ({
                url: interpolate(apiUrls.RULE, { ruleId: id }),
                method: 'PATCH',
                body,
            }),
            invalidatesTags: [ 'RULE', 'RULES' ],
        }),
        deleteRule: build.mutation({
            query: (id) => ({
                url: interpolate(apiUrls.RULE, { ruleId: id }),
                method: 'DELETE',
            }),
            invalidatesTags: [ 'RULES' ],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetRulesQuery,
    useGetRuleByIdQuery,
    useCreateRuleMutation,
    useUpdateRuleMutation,
    useDeleteRuleMutation,
} = rulesApi;
